import { Space, Flex } from "antd";
// import { useMeetingAppContext } from "../../MeetingAppContextDef";
import MicButton from "./buttons/mic";
import LeaveButton from "./buttons/leave";
// import RaiseHandButton from "./buttons/raiseHand";
import WebcamButton from "./buttons/webcam";
// import ChatButton from "./buttons/chat";
// import ParticipantsButton from "./buttons/participants";

const BottomBar = () => {
  // const { setSideBarMode } = useMeetingAppContext();

  return (
    <Flex justify="center">
      <Space>
        {/* <RaiseHandButton /> */}
        <WebcamButton />
        <MicButton />
        <LeaveButton />
        {/* <ChatButton setSideBarMode={setSideBarMode} /> */}
        {/* <ParticipantsButton setSideBarMode={setSideBarMode} /> */}
      </Space>
    </Flex>
  );
};

export default BottomBar;
